import { render } from "./TheatreSchedule.vue?vue&type=template&id=b218ff6c"
import script from "./TheatreSchedule.vue?vue&type=script&lang=js"
export * from "./TheatreSchedule.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__